<template>
  <!-- 巡检考勤 -->
  <div class="active_table">
    <toolbar>
      <div class="search">
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Spin fix v-show="table.loading"></Spin>
    </div>
    <!-- 详情 -->
    <Modal title="巡检详情" v-model="detailsShow" :mask-closable="false">
      <div class="details_header" style="margin-bottom: 20px;">
        <div style="margin-right:20px;">巡检日期：{{ detailsContent.createDate }}</div>
        <div>巡检人：{{ detailsContent.userName }}</div>
      </div>
      <div class="details_content">
        <ul class="ul_header ul_public">
          <li class="device">设备名</li>
          <li class="status">状态</li>
          <li class="active">操作</li>
        </ul>
        <ul class="ul_body ">

          <li v-for="item in detailsContent.inspectionDeviceList" :key="item.id" style="border-bottom: 1px solid #eee;"
            class="ul_public">
            <div class="device">{{ item.deviceName }}</div>
            <div class="status" :style="{ color: item.status == 0 ? 'red' : 'green' }">{{ item.status == 0 ? "异常" : "正常"
              }}</div>
            <div class="active" style="color: #008dfe;cursor: pointer;" @click="openImg(item.imgUrlList)"
              v-if="item.imgUrlList.length != 0">查看图片</div>
            <div class="active" style="color: #888888;" v-if="item.imgUrlList.length == 0">暂无图片</div>
            <div class="remark">备注：{{ item.remark || "无" }}</div>
          </li>
        </ul>
      </div>

      <div slot="footer"></div>
    </Modal>

    <Modal title="图片展示" v-model="publicImgShow" :mask-closable="false">
      <swiper :options="swiperOption">
        <swiper-slide v-for="items in publicImg" :key="items">
          <img :src="items" style="width: 100%;" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div slot="footer"></div>
    </Modal>
    <inspectFormDialog ref="formRef" @success="getData"></inspectFormDialog>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.details_header {
  display: flex;
  font-weight: 700;
  font-size: 14px;
}

.details_content {
  max-height: 60vh;
  overflow: auto;
  font-size: 14px;

  .ul_header {
    font-weight: 700;
  }

  .ul_public {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .device {
      width: 40%;
    }

    .status {
      width: 30%;
    }

    .active {
      width: 30%;
    }
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import inspectFormDialog from "./inspectFormDialog.vue";
import { urgencyLevelMap } from "./dict";

export default {
  data() {
    return {
      urgencyLevelMap: urgencyLevelMap,
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "巡检人",
            key: "realName",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, params.row.realName || "暂无")
              ]);
            }
          },
          {
            title: "站点名称",
            key: "siteName",
            align: "center"
          },
          {
            title: "紧急级别",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {
                  style: {
                    color: "#fff",
                    ...this.getColor(params.row),
                    "border-radius": "12px",
                    height: "24px",
                    padding: "0 10px"
                  }
                }, this.urgencyLevelMap[params.row.urgencyLevel] || "暂无")
              ])
            }
          },
          {
            title: "巡检状态",
            align: "center",
            ellipsis: "true",
            render: (h, params) => {
              return h("div", [
                h("span", {
                  style: {
                    color: params.row.realName ? "green" : "red"
                  }
                }, params.row.realName ? "已巡检" : "未巡检")
              ]);
            }
          },
          {
            title: "巡检日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.createDate) || "暂无")
              ]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$refs.formRef.open(params.row)
                      }
                    }
                  },
                  "去巡检"
                ), h("div", {
                  style: {
                    display: "inline-block",
                    width: "10px" // 增加间隔
                  }
                }), params.row.realName ? h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      backgroundColor: "#FFA500", // 修改按钮背景颜色
                      borderColor: "#FFA500" // 修改按钮边框颜色
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          path: "/chome/workOrder?siteMn=" + params.row.siteMn
                        })
                      }
                    }
                  },
                  "查看工单"
                ) : null
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        siteId: null, // 站点id
        siteDeviceId: null // 设备id
      },
      // 枚举数据
      siteList: [], // 站点枚举列表
      detailsShow: false, // 是否显示详情
      detailsContent: {},  // 巡检详情
      publicImg: [], // 公共图片显示
      publicImgShow: false,
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 2500,
        autoplayDisableOnInteraction: false,
        loop: false,
        coverflow: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true
        }
      }
    };
  },
  components: {
    toolbar,
    inspectFormDialog
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum();
  },
  mounted() {

  },
  methods: {
    getColor(row) {
      if (!row.realName) {
        return {
          "background": "#D8D8D8"
        }
      } else if (row.urgencyLevel == "0") {
        return {
          "background-image": "linear-gradient(118deg, #52F593 0%, #00BE1B 100%)"
        }
      } else if (row.urgencyLevel == "1") {
        return {
          "background-image": "linear-gradient(-82deg, #FF8100 25%, #FFB83A 100%)"
        }
      } else if (row.urgencyLevel == "2") {
        return {
          "background-image": "linear-gradient(-80deg, #FF0037 0%, #FF7357 100%)"
        }
      }
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Event.getInspectionList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给数组中的每个元素添加index索引字段
          res.data.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },

    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取 图片 并显示
    openImg(imgList) {
      this.publicImg = imgList;
      this.publicImgShow = true;
    }
  }
};
</script>